<template>
  <Page class="page" :isIndex="true" :filters="filters" :disable-count="disableCount">
    <div class="title">{{ $t('report.exportIntroduction') }}</div>
    <div class="subtitle">{{ $t('report.collaboratorSource') }}</div>
    <div class="content">
      <CollaboratorOrigins :data="grapheData" />
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Report/BasePage';
import CollaboratorOrigins from '@/components/Analysis/Synthesis/CollaboratorOrigins';

export default {
  name: 'IntroductionProvenancePage',

  components: {
    Page,
    CollaboratorOrigins,
  },

  props: {
    study: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    export: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    filters: {
      type: String,
      required: false,
      default: null,
    },

    disableCount: {
      type: [Boolean, Number],
      required: false,
      default: false,
    },

    filterCollaborators: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  computed: {
    grapheData() {
      let collaborators = this.filterCollaborators.filter(item => item.address != null && item.sites && item.sites.length > 0);

      const regions = collaborators.map(c => ({ region: c.details.region, country: c.details.country }));
      let collaboratorsByRegion = {};
      regions.forEach(region => {
        if (collaboratorsByRegion[region.region]) {
          collaboratorsByRegion[region.region].count++;
        } else {
          collaboratorsByRegion[region.region] = {
            caption: region.region,
            country: region.country,
            count: 1,
          };
        }
      });

      const sortedRegion = Object.values(collaboratorsByRegion).sort((a, b) => {
        return b.count - a.count;
      });

      const graphData =
        sortedRegion.length > 8
          ? [
              ...sortedRegion.slice(0, 7),
              {
                caption: this.$t('other'),
                country: this.$t('other'),
                count: sortedRegion.slice(7, -1).reduce((acc, value) => acc + value.count, 0),
              },
            ].map(e => {
              return { ...e, percentage: (e.count / collaborators.length) * 100 };
            })
          : sortedRegion.map(e => {
              return { ...e, percentage: (e.count / collaborators.length) * 100 };
            });

      return {
        collaboratorsByRegion: this.computeRegionPercentage(graphData),
        filteredCollaboratorsCount: regions.length,
      };
    },
  },

  methods: {
    computeRegionPercentage(regionsData) {
      const diff = 100 - regionsData.map(e => Math.floor(e.percentage)).reduce((acc, val) => acc + val, 0);
      const sortedRegionsData = regionsData.sort((a, b) => Math.floor(a.percentage) - a.percentage - (Math.floor(b.percentage) - b.percentage));

      return sortedRegionsData.map((e, index) => {
        const percentage = index < diff ? Math.floor(e.percentage) + 1 : Math.floor(e.percentage);
        return { ...e, percentage };
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.page {
  padding: 48px 80px;
  box-sizing: border-box;

  .title {
    display: flex;
    flex-direction: column;
    font-size: 32px;
    font-weight: 600;
    color: #3c3c3b;
    margin-bottom: 16px;

    &::after {
      content: '';
      margin: 8px 0;
      width: 64px;
      height: 4px;
      border-radius: 4px;
      background: colors.$main-color;
    }
  }

  .subtitle {
    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-weight: 200;
    color: #3c3c3b;
    margin-bottom: 16px;
  }

  .content {
    display: flex;
  }
}
</style>
